module.exports = __webpack_public_path__ + "img/ai-award.Actics.feeef8c4.png";